module.exports = __webpack_public_path__ + "static/media/ice-cream.68a92199.svg";